import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
Vue.use(VueRouter);



const routes = [
  {
    path: "/news_collection",
    name: "news_collection",
    component: resolve => require(['../views/news_collection/index.vue'], resolve),
    // component: () => import("../views/news_collection/index.vue"),
    meta: {
      title: '收藏',
      keepAlive: true,  // 需要缓存
      tokenAuth: true
    }
  },
  {
    path: "/useragreement",
    name: "useragreement",
    component: resolve => require(['../views/agreement/user.vue'], resolve),
    // component: () => import("../views/agreement/user.vue"),
    meta: {
      title: '用户协议'
    }
  },
  {
    path: "/secretagreement",
    name: "secretagreement",
    component: resolve => require(['../views/agreement/secret.vue'], resolve),
    // component: () => import("../views/agreement/secret.vue"),
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: "/business_agreement",
    name: "business_agreement",
    component: resolve => require(['../views/agreement/business_agreement.vue'], resolve),
    // component: () => import("../views/agreement/business_agreement.vue"),
  },
  {
    path: "/CashcardVoucher",
    name: "CashcardVoucher",
    component: resolve => require(['../views/CashcardVoucher/index.vue'], resolve),
    // component: () => import("../views/CashcardVoucher/index.vue"),
    meta: {
      title: '兑换卡券'
    }
  },
  {
    path: "/myCardBag",
    name: "myCardBag",
    component: resolve => require(['../views/myCardBag/index.vue'], resolve),
    // component: () => import("../views/myCardBag/index.vue"),
    meta: {
      title: '我的卡包',
      keepAlive: true,  // 需要缓存
      tokenAuth: true
    }
  },
  {
    path: "/Invalidcoupon",
    name: "Invalidcoupon",
    component: resolve => require(['../views/myCardBag/Invalidcoupon.vue'], resolve),
    // component: () => import("../views/myCardBag/Invalidcoupon.vue"),
    meta: {
      title: '失效卡包',
      keepAlive: true,  // 需要缓存
      tokenAuth: true
    }
  },
  {
    path: "/myCardBag_detail",
    name: "myCardBag_detail",
    component: resolve => require(['../views/myCardBagDetail/detail.vue'], resolve),
    // component: () => import("../views/myCardBagDetail/detail.vue"),
    meta: {
      title: '卡券详情',
      tokenAuth: true
    }
  },
  {
    path: "/TouseRecord",
    name: "TouseRecord",
    component: resolve => require(['../views/myCardBag/TouseRecord.vue'], resolve),
    // component: () => import("../views/myCardBag/TouseRecord.vue"),
    meta: {
      title: '抵扣记录',
      tokenAuth: true
    }
  },
  {
    path: "/travel_records",
    name: "travel_records",
    component: resolve => require(['../views/travelRecords/index.vue'], resolve),
    // component: () => import("../views/travelRecords/index.vue"),
    meta: {
      title: '行程列表',
      keepAlive: true,  // 需要缓存
      tokenAuth: false
    }
  },
  {
    path: "/travel_records_details",
    name: "travel_records_details",
    component: resolve => require(['../views/travelRecords/details.vue'], resolve),
    // component: () => import("../views/travelRecords/details.vue"),
    meta: {
      title: '行程详情',
      keepAlive: true,  // 需要缓存
      tokenAuth: true
    }
  },
  {
    path: "/scheduleComplaint",
    name: "scheduleComplaint",
    component: resolve => require(['../views/scheduleComplaint/index.vue'], resolve),
    // component: () => import("../views/travelRecords/details.vue"),
    meta: {
      title: '行程申诉',
      // keepAlive: true,  // 需要缓存
      tokenAuth: true
    }
  },
  {
    path: "/complaintResults",
    name: "complaintResults",
    component: resolve => require(['../views/scheduleComplaint/result.vue'], resolve),
    // component: () => import("../views/travelRecords/details.vue"),
    meta: {
      title: '申诉详情',
      // keepAlive: true,  // 需要缓存
      tokenAuth: true
    }
  },
  {
    path: "/timetable",
    name: "timetable",
    component: resolve => require(['../views/timetable/index.vue'], resolve),
    // component: () => import("../views/timetable/index.vue"),
    meta: {
      title: '首末班车时刻表'
    }
  },
  {
    path: "/businesscard",
    name: "businesscard",
    component: resolve => require(['../views/businesscard/index.vue'], resolve),
    // component: () => import("../views/businesscard/index.vue"),
    meta: {
      title: ''
    }
  },
  {
    path: "/articleparticular",
    name: "articleparticular",
    component: resolve => require(['../views/articleparticular/index.vue'], resolve),
    // component: () => import("../views/articleparticular/index.vue"),
    meta: {
      title: '文章详情'
    }
  },
  {
    path: "/download",
    name: "download",
    component: resolve => require(['../views/download/index.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '下载兰州轨道'
    }
  },
  {
    path: "/toGuideList",
    name: "toGuideList",
    component: resolve => require(['../views/toGuide/index.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '乘车指南'
    }
  }, {
    path: "/toGuideDetail",
    name: "toGuideDetail",
    component: resolve => require(['../views/toGuide/detail.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '乘车指南'
    },

  },
  {
    path: "/loveAppointment",
    name: "loveAppointment",
    component: resolve => require(['../views/loveAppointment/index.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '爱心预约'
    }
  },
  {
    path: "/passengerNotice",
    name: "passengerNotice",
    component: resolve => require(['../views/passengerNotice/index.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '乘客须知'
    }
  },
  {
    path: "/chooseTravel",
    name: "chooseTravel",
    component: resolve => require(['../views/invoice/chooseTravel/index.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '开具发票',
      keepAlive: true,  // 需要缓存
      tokenAuth: true
    }
  },
  {
    path: "/fillInvoice",
    name: "fillInvoice",
    component: resolve => require(['../views/invoice/fillInvoice/index.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '开具发票',
      tokenAuth: true
    }
  },
  {
    path: "/InvoiceSuccess",
    name: "InvoiceSuccess",
    component: resolve => require(['../views/invoice/replaySuccess/index.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '申请成功',
      tokenAuth: true
    }
  },
  {
    path: "/InvoiceRecord",
    name: "InvoiceRecord",
    component: resolve => require(['../views/invoice/record/index.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '开票历史',
      keepAlive:true,
      tokenAuth: true
    }
  },
  {
    path: "/invoiceDetail",
    name: "invoiceDetail",
    component: resolve => require(['../views/invoice/invoiceDetail/index.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '开票详情',
      keepAlive:true,
      tokenAuth: true
    }
  },
  {
    path: "/invoiceDetail_travel",
    name: "invoiceDetail_travel",
    component: resolve => require(['../views/invoice/invoiceDetail/travel.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '开票行程',
      tokenAuth: true
    }
  },
  {
    path: "/invoiceDetail_makedetail",
    name: "invoiceDetail_makedetail",
    component: resolve => require(['../views/invoice/invoiceDetail/detail.vue'], resolve),
    // component: () => import("../views/download/index.vue"),
    meta: {
      title: '发票详情',
      tokenAuth: true
    }
  },
  {
    path: "/answerBuy",
    name: "answerBuy",
    component: resolve => require(['../views/answerBuy/index.vue'], resolve),
    meta: {
      title: '国安普法 答题抢票',
      keepAlive: true,  // 需要缓存
      tokenAuth: false
    }
  },
  {
    path: "/answerInfo",
    name: "answerInfo",
    component: resolve => require(['../views/answerInfo/index.vue'], resolve),
    meta: {
      title: '国安普法 答题抢票',
      keepAlive: true,  // 需要缓存
      tokenAuth: false
    }
  },
  {
    path: '/share-sdk',
    name: 'shareSdk',
    component: resolve => require(['../views/shareSdk/index.vue'], resolve),
    // component: () => import("../views/share-sdk/index.vue"),
    meta: {
      title: '个人信息第三方共享清单',
      keepAlive: true, 
      tokenAuth: false
    }
  }
];


const router = new VueRouter({
  routes,
});

export default router;




